import { useStores } from './useStores'

export const useAuth = () => {
  const { store } = useStores()
  const isLogin = !!store.token
  const isCreator = store.userinfo?.userRoleInfo?.artist
  const isAiCreator = store.userinfo?.userRoleInfo?.aiArtist

  return {
    /** 是否已登录 */
    isLogin,
    /** 是否已成为普通创作者  */
    isCreator,
    /** 是否已成为AI创作者  */
    isAiCreator,
  }
}
